<template>
  <el-dialog
    center
    title="设置展示信息"
    :visible="true"
    :before-close="() => $emit('close')"
    top="7vh"
    width="900px"
  >
    <el-row>
      <el-col :span="12">
        <span style="font-weight:bold">基本信息</span>
        <el-checkbox v-model="basic" @change="basicCheckAll">
          全选
        </el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="checkedBasic" @change="basicChecked">
          <div v-for="(item, index) in basicList" :key="index">
            <el-checkbox
              @change="
                e => {
                  clearCheck(e, index, basicList);
                }
              "
              :key="'basic' + item.prop"
              :label="'basic' + item.prop"
            ></el-checkbox>
            <el-tooltip
              v-if="
                item.dataType === 1 ||
                  item.dataType === 4 ||
                  item.dataType === 5
              "
              class="item"
              effect="dark"
              :content="item.label"
              placement="top"
              :disabled="item.label.length < 21"
            >
              <el-input
                :placeholder="item.label"
                v-model="item.conditionKey"
                :disabled="
                  !checkedBasic.includes('basic' + item.prop) ||
                    item.disable === 1
                "
              ></el-input>
            </el-tooltip>
            <el-date-picker
              v-else-if="item.dataType === 2"
              v-model="item.conditionKey"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              :start-placeholder="item.label + '起'"
              :end-placeholder="item.label + '止'"
              :disabled="!checkedBasic.includes('basic' + item.prop)"
            ></el-date-picker>
            <el-date-picker
              v-else-if="item.dataType === 6"
              v-model="item.conditionKey"
              type="monthrange"
              range-separator="至"
              :start-placeholder="item.label + '起'"
              :end-placeholder="item.label + '止'"
              :disabled="!checkedBasic.includes('basic' + item.prop)"
            ></el-date-picker>
            <el-tooltip
              v-else-if="[3, 7].includes(item.dataType)"
              class="item"
              effect="dark"
              :content="item.label"
              placement="top"
              :disabled="item.label.length < 21"
            >
              <el-select
                v-model="item.conditionKey"
                clearable
                filterable
                collapse-tags
                :placeholder="item.label"
                :disabled="!checkedBasic.includes('basic' + item.prop)"
              >
                <el-option
                  v-for="citem in item.options"
                  :key="citem.value"
                  :label="citem.label ? citem.label : citem"
                  :value="citem.value ? citem.value : citem"
                ></el-option>
              </el-select>
            </el-tooltip>
            <el-tooltip
              v-if="item.dataType === 31"
              class="item"
              effect="dark"
              :content="item.label"
              placement="top"
              :disabled="item.label.length < 21"
            >
              <el-autocomplete
                :placeholder="item.label"
                v-model="item.conditionKey"
                :maxlength="30"
                :fetch-suggestions="
                  (queryString, cb) => {
                    cb(
                      [{ value: '未设置' }].filter(
                        i => !queryString || i.value.indexOf(queryString) > -1
                      )
                    );
                  }
                "
                @select="
                  item => {
                    item.conditionKey = item.value;
                  }
                "
                :disabled="
                  !checkedBasic.includes('basic' + item.prop) ||
                    item.disable === 1
                "
              ></el-autocomplete>
            </el-tooltip>
          </div>
        </el-checkbox-group>
      </el-col>
      <el-col :span="12">
        <span style="font-weight:bold">其他信息</span>
        <el-checkbox v-model="other" @change="otherCheckAll">
          全选
        </el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="checkedOther" @change="otherChecked">
          <div v-for="(item, index) in otherList" :key="index">
            <span
              style="font-size:14px;color:#c0c4cc;margin-right:10px"
              v-if="[5, 20].includes(+projectType)"
            >
              {{ index + 1 }}
            </span>
            <el-checkbox
              @change="
                e => {
                  clearCheck(e, index, otherList);
                }
              "
              :key="'other' + item.prop"
              :label="'other' + item.prop"
            ></el-checkbox>
            <el-tooltip
              v-if="[1, 4, 5, 9].includes(item.dataType)"
              class="item"
              effect="dark"
              :content="item.label"
              placement="top"
              :disabled="item.label.length < 21"
            >
              <el-input
                :placeholder="item.label"
                v-model="item.conditionKey"
                :disabled="
                  !checkedOther.includes('other' + item.prop) ||
                    item.disable === 1
                "
              ></el-input>
            </el-tooltip>
            <!-- dataType:8 数字填空题 为区间 -->
            <div style="display: inline-block;" v-else-if="item.dataType === 8">
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.label"
                placement="top"
                :disabled="item.label.length < 8"
              >
                <el-input
                  style="width: 150px;"
                  :placeholder="item.label"
                  v-model="item.conditionKey[0]"
                  @focus="
                    item.conditionKey = Array.isArray(item.conditionKey)
                      ? item.conditionKey
                      : ['', '']
                  "
                  @input="
                    e => {
                      item.conditionKey[0] = limitToNum(e);
                    }
                  "
                  :disabled="
                    !checkedOther.includes('other' + item.prop) ||
                      item.disable === 1
                  "
                ></el-input>
              </el-tooltip>
              <span style="font-size:15px;margin-left: 8px;">——</span>
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.label"
                placement="top"
                :disabled="item.label.length < 8"
              >
                <el-input
                  style="width: 150px;"
                  :placeholder="item.label"
                  v-model="item.conditionKey[1]"
                  @focus="
                    item.conditionKey = Array.isArray(item.conditionKey)
                      ? item.conditionKey
                      : ['', '']
                  "
                  @input="
                    e => {
                      item.conditionKey[1] = limitToNum(e);
                    }
                  "
                  :disabled="
                    !checkedOther.includes('other' + item.prop) ||
                      item.disable === 1
                  "
                ></el-input>
              </el-tooltip>
            </div>
            <el-tooltip
              v-else-if="item.dataType === 2 || item.dataType === 6"
              class="item"
              effect="dark"
              :content="item.label"
              placement="top"
              :disabled="item.label.length < 8"
            >
              <el-date-picker
                v-if="item.dataType === 2"
                v-model="item.conditionKey"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                :start-placeholder="item.label + '起'"
                :end-placeholder="item.label + '止'"
                :disabled="!checkedOther.includes('other' + item.prop)"
              ></el-date-picker>
              <el-date-picker
                v-else-if="item.dataType === 6"
                v-model="item.conditionKey"
                style="width: 350px;"
                type="monthrange"
                value-format="yyyy-MM"
                range-separator="至"
                :start-placeholder="item.label + '起'"
                :end-placeholder="item.label + '止'"
                :disabled="!checkedOther.includes('other' + item.prop)"
              ></el-date-picker>
            </el-tooltip>
            <el-tooltip
              v-else-if="item.dataType === 3 || item.dataType === 7"
              class="item"
              effect="dark"
              :content="item.label"
              placement="top"
              :disabled="item.label.length < 21"
            >
              <el-select
                v-model="item.conditionKey"
                clearable
                :placeholder="item.label"
                :disabled="!checkedOther.includes('other' + item.prop)"
              >
                <el-option
                  v-for="citem in item.options"
                  :key="citem.value"
                  :label="citem.label ? citem.label : citem"
                  :value="citem.value ? citem.value : citem"
                >
                  <el-tooltip
                    v-if="(citem.label ? citem.label : citem).length > 30"
                    placement="top"
                    effect="dark"
                    :content="citem.label ? citem.label : citem"
                  >
                    <p>
                      {{ (citem.label ? citem.label : citem).slice(0, 30) }}...
                    </p>
                  </el-tooltip>
                  <p v-else>{{ citem.label ? citem.label : citem }}</p>
                </el-option>
              </el-select>
            </el-tooltip>
          </div>
        </el-checkbox-group>
      </el-col>
      <span class="quick-tips">
        注：选择相应的字段后，将会在列表显示
      </span>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { quickAudit } from '../../api';

export default {
  //dataType:1：文本 2：时间 3：选择(不带value选择题) 4：图片地址 5：html地址 6：月度 7 :带value选择题 8 :数字填空题
  name: 'setTableHead',
  props: {
    projectId: {
      type: [String, Number]
    },
    type: {
      type: [String, Number]
    },
    firstEnter: {
      type: [String, Number],
      default: 1
    },
    isOpenedByOther: {
      type: [Boolean]
    }
  },
  data() {
    return {
      //基本信息
      basic: true, //默认是否全选
      checkedBasic: [], //选取的基本信息list
      basicList: [], //用做渲染基本信息控件的list
      //其他信息
      other: false,
      checkedOther: [],
      otherList: []
    };
  },
  computed: {
    projectType() {
      return this.$store.state.homeProject.projectType;
    }
  },
  methods: {
    limitToNum(data) {
      let num = data
        .replace(/[^\d.-]/g, '')
        //只允许一个小数点
        .replace(/^\./g, '')
        .replace(/\.{2,}/g, '.')
        //只能输入小数点后两位
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.');
      return num;
    },
    searchRule(list) {
      let ruleError = list.find(item => {
        if (+item.dataType === 8 && Array.isArray(item.conditionKey)) {
          //因为区间搜索需要全部填或者全部不填
          //所以判断第一个字段没有值并且第二个字段有值返回 error
          if (!item.conditionKey[0] && item.conditionKey[1]) {
            this.$message.error('请填写正确的数字区间');
            return item;
          } else if (!item.conditionKey[1] && item.conditionKey[0]) {
            this.$message.error('请填写正确的数字区间');
            return item;
          } else if (
            isNaN(+item.conditionKey[0]) ||
            isNaN(+item.conditionKey[1])
          ) {
            this.$message.error('请填写正确的数字区间');
            return item;
          } else if (+item.conditionKey[0] > +item.conditionKey[1]) {
            this.$message.error('请填写正确的数字区间');
            return item;
          }
        }
      });
      if (ruleError) {
        return false;
      } else {
        return true;
      }
    },

    clearCheck(e, i, list) {
      if (!e) {
        list[i].conditionKey = '';
      }
    },
    save() {
      //所选项条数
      const isSelectNum = this.checkedBasic.length + this.checkedOther.length;
      if (isSelectNum > 30) {
        this.$message.error('最多选择30项内容展示');
        return;
      }
      if (isSelectNum < 1) {
        this.$message.error('至少选择一项展示');
        return;
      }
      //筛选选中的数据
      const basicCheckedList = this.basicList.filter(item => {
        return this.checkedBasic.indexOf('basic' + item.prop) !== -1;
      });
      const otherCheckedList = this.otherList.filter(item => {
        return this.checkedOther.indexOf('other' + item.prop) !== -1;
      });
      const list = [...basicCheckedList, ...otherCheckedList];
      //数字区间校验
      if (!this.searchRule(list)) {
        return;
      }
      const cacheCheck = {
        checkedBasic: [...this.checkedBasic],
        checkedOther: [...this.checkedOther]
      };
      //储存快捷审核需要的表头信息
      sessionStorage.setItem('quickCheckedList', JSON.stringify(list));
      //根据id储存快捷审核所选内容
      localStorage.setItem(
        this.projectId + '_task-auto-check',
        JSON.stringify(cacheCheck)
      );
      if (this.$route.name === 'taskQuickAuditList') {
        //如果弹出层在快捷审核列表页面则刷新快捷审核列表
        this.$emit('refresh');
      } else {
        //否则携带数据跳转至快捷审核列表
        this.$router.push({
          name: 'taskQuickAuditList',
          query: {
            projectId: this.projectId,
            type: this.type,
            isOpenedByOther: this.isOpenedByOther ? 1 : 0
          }
        });
      }
      this.$emit('close');
    },
    //基本信息
    basicCheckAll(val) {
      let basicCheckAllList = this.basicList.map((item, index) => {
        this.clearCheck(val, index, this.basicList);
        return 'basic' + item.prop;
      });
      this.checkedBasic = val ? basicCheckAllList : [];
    },
    basicChecked(value) {
      this.basic = value.length === this.basicList.length;
    },
    //其他信息
    otherCheckAll(val) {
      let otherCheckList = this.otherList.map((item, index) => {
        this.clearCheck(val, index, this.otherList);
        return 'other' + item.prop;
      });
      this.checkedOther = val ? otherCheckList : [];
    },
    otherChecked(value) {
      this.other = value.length === this.otherList.length;
    },
    //查看项目是否有缓存数据
    taskCheck() {
      const isCache = localStorage.getItem(this.projectId + '_task-auto-check');
      if (isCache) {
        // 如果有缓存
        this.checkedBasic = JSON.parse(isCache).checkedBasic;
        this.checkedOther = JSON.parse(isCache).checkedOther;
        if (this.checkedOther.length === this.otherList.length) {
          this.other = true; //其他信息全选按钮
        }
        if (this.checkedBasic.length < this.basicList.length) {
          this.basic = false; //基本信息全选按钮
        }
      } else {
        this.basicCheckAll(true); //基本默认信息全选
      }
    }
  },
  created() {
    quickAudit
      .getDisplayInfo({
        projectId: this.projectId,
        firstEnter: this.firstEnter
      })
      .then(res => {
        this.basicList = res.data.data.baseInfos.map(item => {
          return { ...item, conditionKey: '' };
        });
        this.otherList = res.data.data.generalExtendInfos.map(item => {
          return { ...item, conditionKey: '' };
        });
        this.taskCheck();
      });
  }
};
</script>

<style scoped lang="scss">
>>> .el-select__tags {
  margin-left: 10px;
}
>>> .el-checkbox__label {
  display: none;
}
>>> .el-input {
  width: 350px;
  margin-left: 10px;
}
>>> .el-date-editor {
  margin-left: 10px;
}

>>> .el-checkbox {
  margin-top: 20px !important;
}
>>> .el-row {
  max-height: 70vh;
  overflow-y: auto;
}
.dialog-footer {
  text-align: center;
}
.quick-tips {
  background: #fef0f0;
  color: #f56c6c;
  line-height: 50px;
  width: 95%;
  margin-top: 20px;
  display: inline-block;
  clear: both;
}
</style>
